// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1pOL-","content":"Consent_content__2fg8d","footer":"Consent_footer__2lxWM"};